import { useNavigate } from 'react-router-dom'

import { F0Button } from '@factorialco/f0-react'
import { ExternalLink } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const NavigateToCompensation = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const gotoCompensations = () => {
    track(trackingEvents.accounting.newFinancialWorkspace.compensation.navigateToCompensations)
    navigate(navigation.compensations.fullPath())
  }

  return (
    <F0Button
      onClick={gotoCompensations}
      variant={'outline'}
      icon={ExternalLink}
      label={i18n.t('finance.financial_workspace.compensations.upload_banner.cta.upload')}
    />
  )
}
